// src/context/LanguageContext.js
import React, { createContext, useContext, useMemo } from 'react';
import { translations } from '../locales';
import { usePersistedState } from '../hooks/usePersistedState';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = usePersistedState('appLanguage', 'zh');
  
  const t = useMemo(() => (key) => {
    return translations[language]?.[key] || key; 
  }, [language]);

  return (
    <LanguageContext.Provider value={{ t, language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
